module.exports = __webpack_public_path__ + "01_mole.eeac8e23.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer2/01_mole.png
// module id = c9Rj
// module chunks = 0